import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import googlePlay from '../assets/img/svg/google-play.svg'
import app from '../assets/img/svg/apple-store.svg'
import logoblanco from '../assets/img/logoblanco.webp'

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="dark-footer skin-dark-footer">
        <div className="container">
            <div className="row">
                
                <div className="col-lg-3 col-md-4">
                    <div className="footer-widget">
                    <Link className="nav-footer-logo d-flex align-items-center" to="/">
                    <img
                        src={logoblanco}
                        alt="AMPI"
                        width={150}
                        height={55}
                        className="me-2"
                        loading="lazy"
                    />
                    </Link>


                        <div className="footer-add">
                            <p>{t('footer.aboutDescription')}</p>
                            <p>+52 322 297 5322</p>
                            <p>ampi.nayarit@gmail.com</p>
                        </div>
                        
                    </div>
                </div>
                
                <div className="col-lg-2 col-md-6">
                    <div className="footer-widget">
                        <h4 className="widget-title">{t('footer.propertiesTitle')}</h4>
                        <ul className="footer-menu">
                            <li><Link to="/agents">{t('footer.viewProperties')}</Link></li>
                            <li><Link to="/submit-property">{t('footer.publishProperty')}</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-2 col-md-6">
                    <div className="footer-widget">
                        <h4 className="widget-title">{t('footer.membersTitle')}</h4>
                        <ul className="footer-menu">
                            <li><Link to="/agents">{t('navigation.affiliates')}</Link></li>
                            <li><Link to="/asociados">{t('navigation.associates')}</Link></li>
                            <li><Link to="/agencies">{t('agency.agencies')}</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-2 col-md-6">
                    <div className="footer-widget">
                        <h4 className="widget-title">{t('footer.coursesTitle')}</h4>
                        <ul className="footer-menu">
                            <li><Link to="/ver-taller">{t('footer.viewCourses')}</Link></li>
                            <li><Link to="/ins-taller">{t('footer.enrollCourse')}</Link></li>
                            <li><Link to="/calificacion">{t('navigation.addReview')}</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6">
                    <div className="footer-widget">
                        <h4 className="widget-title">{t('footer.companyTitle')}</h4>
                        <ul className="footer-menu">
                            <li><a href="https://ampirivieranayarit.com/" target="_blank" rel="noopener noreferrer">{t('footer.aboutUs')}</a></li>
                            <li><a href="https://ampirivieranayarit.com/contact-us/" target="_blank" rel="noopener noreferrer">{t('footer.contact')}</a></li>
                            <li><Link to="/ayuda">{t('footer.helpCenter')}</Link></li>
                            <li><Link to="/ayuda/faq">{t('footer.faq')}</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    
        <div className="footer-bottom">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <p className="mb-0">© {new Date().getFullYear()} AMPI Riviera Nayarit. {t('footer.rights')}</p>
                    </div>
                    <div className="col-lg-6 col-md-6 text-right">
                        <ul className="footer-bottom-social">
                            <li><Link to="https://www.facebook.com/AMPIRivieraNayarit" target='_blank' rel="noopener noreferrer" aria-label="Visítanos en Facebook"><i className="fa-brands fa-facebook" aria-hidden="true"></i></Link></li>
                            <li><Link to="https://www.tiktok.com/@ampirivieranayarit" target='_blank' rel="noopener noreferrer" aria-label="Visítanos en TikTok"><i className="fa-brands fa-tiktok" aria-hidden="true"></i></Link></li>
                            <li><Link to="https://www.instagram.com/ampirivieranayarit/" target='_blank' rel="noopener noreferrer" aria-label="Visítanos en Instagram"><i className="fa-brands fa-instagram" aria-hidden="true"></i></Link></li>
                            <li><Link to="https://www.linkedin.com/in/ampi-riviera-nayarit-485a20361/" target='_blank' rel="noopener noreferrer" aria-label="Visítanos en LinkedIn"><i className="fa-brands fa-linkedin" aria-hidden="true"></i></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}
